import { render, staticRenderFns } from "./CarregarBannerPromocional.vue?vue&type=template&id=13774cba&"
import script from "./CarregarBannerPromocional.vue?vue&type=script&lang=js&"
export * from "./CarregarBannerPromocional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports